import { paletteFor } from '../../../shared/catalog.js'
import { SystemTile } from './SystemTile.jsx'

// The @-token (§5.2). `system` may be missing (renamed or deleted system):
// the chip then shows the label stored in the question.

const VARIANTS = {
  message: { padding: '1px 7px 1px 3px', fontSize: 14, tile: 'md', at: true, margin: '0 3px 0 0' },
  composer: { padding: '1px 7px 1px 3px', fontSize: 14, tile: 'md', at: true, margin: '0 2px' },
  answer: { padding: '2px 8px 2px 3px', fontSize: 13, tile: 'md', at: false, margin: 0 },
  card: { padding: '1px 7px 1px 3px', fontSize: 12.5, tile: 'sm', at: true, margin: 0 },
}

export function MentionChip({ system, label, variant = 'message' }) {
  const v = VARIANTS[variant] ?? VARIANTS.message
  const palette = paletteFor(system?.palette)
  const name = system?.name ?? label ?? 'Unknown system'
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        borderRadius: 6,
        padding: v.padding,
        margin: v.margin,
        background: palette.chipBg,
        color: palette.chipText,
        fontSize: v.fontSize,
        fontWeight: 500,
        verticalAlign: 'baseline',
        whiteSpace: 'nowrap',
        lineHeight: 1.5,
      }}
    >
      <SystemTile system={system ?? { letter: name[0], palette: 'slate', status: 'ready' }} size={v.tile} />
      {v.at ? '@' : ''}
      {name}
    </span>
  )
}
